import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import { OrderStatus } from 'interfaces';
import { Banner } from 'storybook';

import styles from './FreeOrderBanner.module.css';

type FreeOrderBannerProps = {
   orderStatus: OrderStatus;
   isOrderAddedToNextOrder: boolean;
   isClientView?: boolean;
   orderAddedToOrderId: string | null;
   className?: string;
};

const FreeOrderBanner = ({
   orderStatus,
   isOrderAddedToNextOrder,
   isClientView,
   orderAddedToOrderId,
   className,
}: FreeOrderBannerProps) => {
   const { t } = useTranslation();

   const freeOrderText = isClientView
      ? t('freeOrderBanner.clientFreeText')
      : t('freeOrderBanner.supplierFreeText');

   const getBannerText = () => {
      if (!isOrderAddedToNextOrder) {
         return freeOrderText;
      } else if (orderStatus === 'ENDED' && orderAddedToOrderId) {
         return t('freeOrderBanner.addedToOrderEnded', {
            orderId: orderAddedToOrderId,
         });
      }
      return (
         <>
            <p>{freeOrderText}</p>
            <p>
               {isClientView
                  ? t('freeOrderBanner.clientNextOrderInfo')
                  : t('freeOrderBanner.supplierNextOrderInfo')}
            </p>
         </>
      );
   };

   return (
      <Banner
         fullWidth
         variant="info"
         className={classNames(styles.banner, className)}
         children={getBannerText()}
      />
   );
};

export default FreeOrderBanner;
